import React, { useRef } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { Dispatch } from 'redux';
import { useOnScrollToTop } from 'hooks/useScrollToTop';
import ORB1CoverPage from './ORB1CoverPage';
import ORB1Print from './ORB1Print';
import orb1Selectors from 'redux/app/orb1/selectors';
import { IStore } from 'redux/store';

type OwnProps = {
    showCoverPages?: boolean;
	vesselId: string;
};
type ORB1HistoryProps = PropsFromRedux & OwnProps;

function ORB1InspectorView(props: ORB1HistoryProps) {
    const { historyList, showCoverPages = false, vesselId } = props;
    const topDivRef = useRef<HTMLDivElement | null>(null);
    useOnScrollToTop(topDivRef);

    return (
        <div>
            <div className="h-0" ref={topDivRef} />
            {showCoverPages ? <ORB1CoverPage vesselId={vesselId} /> : null}
            <div className="newpage py-4 px-8">
                <ORB1Print
                    key={'temp-print-id'}
                    isPrintVisible={true}
                    orb1Records={historyList}
                    showShipInfo={showCoverPages}
					vesselId={vesselId}
                />
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const orb1RecordStore = orb1Selectors._getStore(store);
    return {
        historyList: orb1Selectors.getHistoryList(orb1RecordStore),
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(ORB1InspectorView);
